import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import AdminLogin from "./pages/auth/AdminLogin";
import AdminDashboard from "./pages/dashboard/dashboard";
import UserManagement from "./pages/management/UserManagement";
import CustomToaster from "./components/common/CustomToaster";
import AuthProvider from "./components/common/AuthProvider";
import AgentManagement from "./pages/management/AgentManagement";
import Notice from "./pages/management/Notice";
import Faq from "./pages/management/Faq";
import Odo from "./pages/management/Odo";
import AgentCreateTool from "./pages/management/AgentCreateTool";

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="h-full w-full">
          <Routes>
            <Route path="/auth/login" element={<AdminLogin />} />
            <Route path="/" element={<AdminDashboard />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/agent-management" element={<AgentManagement />} />
            <Route
              path="/agent-management/create"
              element={<AgentCreateTool />}
            />
            <Route path="/service-management/notice" element={<Notice />} />
            <Route path="/service-management/faq" element={<Faq />} />
            <Route path="/service-management/inquiry" element={<Odo />} />
          </Routes>
          <CustomToaster />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
